module.exports = __webpack_public_path__ + "static/media/torso-top-left-side.b9ea6de4.png";